import { getTimelineSynopsis } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTimelineSynopsisGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreTimelineSynopsis',
	receive: true,
	request: true,
	requestHandler: getTimelineSynopsis,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
